import { LanguageContext } from 'context/languageContext';
import { TFunction } from '@/lib/i9s/types';
import { useContext } from 'react';

import styles from './index.module.css';
import { CityContext } from '@/context/cityContext';
import { useRequest } from 'ahooks';
import { getTopCategories } from '@/lib/api/methods';
import { isAxiosError } from 'axios';
import Link from 'next/link';

const items = (t: TFunction) => {
  return [
    {
      image: '/assets/sport.png',
      text: t('spLs'),
      menu: [
        { text: t('bicycles'), link: 'link' },
        { text: t('escooters'), link: 'link' },
        { text: t('hiking'), link: 'link' },
        { text: t('alpineSkiing'), link: 'link' },
        { text: t('snowboarding'), link: 'link' },
      ],
    },
    {
      image: '/assets/audio.png',
      text: t('audiVide'),
      menu: [
        { text: t('gameConsoles'), link: 'link' },
        { text: t('cameras'), link: 'link' },
        { text: t('lighting'), link: 'link' },
        { text: t('projectors'), link: 'link' },
        { text: t('audio'), link: 'link' },
      ],
    },
    {
      image: '/assets/construction.png',
      text: t('constrRepair'),
      menu: [
        { text: t('stepladders'), link: 'link' },
        { text: t('cuttingEquipment'), link: 'link' },
        { text: t('drillsAndScrewdrivers'), link: 'link' },
        { text: t('tools'), link: 'link' },
        { text: t('other'), link: 'link' },
      ],
    },
    {
      image: '/assets/home.png',
      text: t('home'),
      menu: [
        { text: t('heaters'), link: 'link' },
        { text: t('streamers'), link: 'link' },
        { text: t('windowWashers'), link: 'link' },
        { text: t('vacuumCleaners'), link: 'link' },
        { text: t('other'), link: 'link' },
      ],
    },
    {
      image: '/assets/baby.png',
      text: t('babyProds'),
      menu: [
        { text: t('strollers'), link: 'link' },
        { text: t('eventSuits'), link: 'link' },
        { text: t('babySeats'), link: 'link' },
        { text: t('other'), link: 'link' },
      ],
    },
    {
      image: '/assets/others.png',
      text: t('others'),
      menu: [{ text: t('anythingElse'), link: 'link' }],
    },
  ];
};

const PopularItems = () => {
  const { t, language } = useContext(LanguageContext);
  const { choosenCity, treeDataCountry, cityInfo } = useContext(CityContext);
  const countryIsoCode = choosenCity[0];

  const onError = (error) => {
    if (isAxiosError(error) && error.response) {
      openNotificationWithIcon('error', error.response.data.message);
    } else {
      openNotificationWithIcon('error', error.message);
    }
  };

  const { loading: loadingTopCategoies, data: topCategories } = useRequest(
    () =>
      getTopCategories(+choosenCity[1], {
        headers: {
          'country-iso-code': treeDataCountry.find(
            (c) => c.value === choosenCity[0]
          ).slug,
          'accept-language': language,
        },
      }),
    {
      ready: !!countryIsoCode && !!language && !!choosenCity[1],
      refreshDeps: [language, countryIsoCode, choosenCity[1]],
      onError,
    }
  );

  return topCategories ? (
    <div className={styles.container}>
      <div className={styles.containerWrapper}>
        <div className={styles.header}>{t('popular')}</div>
        <div className={styles.itemsWrapper}>
          {topCategories?.map((el, i) => {
            return (
              <div key={i} className={styles.item}>
                <div className={styles.imageWrapper}>
                  <img src={el.photoUrl} width={80} height={80} alt="img" />
                </div>
                <Link
                  href={`${window.location.origin}/${el.url}`}
                  className={styles.text}
                >
                  {el.category}
                </Link>

                <div className={styles.menu}>
                  {el.groups.map((element, j) => (
                    <Link
                      href={`${window.location.origin}/${element.url}`}
                      key={element.name + j}
                      className={styles.menuItem}
                      style={el.category.length === 1 ? { width: 195 } : null}
                    >
                      {element.name}
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : (
    <div></div>
  );
};

export default PopularItems;
function openNotificationWithIcon(arg0: string, message: any) {
  throw new Error('Function not implemented.');
}
